import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { CustomProgressDottedBar, Line } from "../components/circle-line.js";
import {
  AgmodalStore,
  EntityV2Store,
  bookingsStore,
  cargoStore,
  configStore,
  containerStore,
  contractsStore,
  entityStore,
  loginStore,
} from "../state/CommonState.js";
import Utils from "../util/Utils.js";
import schLogoMap from "../enquiry/carrier-logo.js";
import LCLPricingSchedule from "../pricing/lcl.schedule.js";
import FCLChargeClientViewv2 from "./FCLChargeClientView-v3.js";
import RoleUtils from "../util/RoleUtils.js";
import { BRANCH_STATUS, ENTITY_STATUS, PERMISSIONS, PERMISSIONS_NEW } from "../util/constants.js";
import airlogoMap from "../enquiry/air-logo.js";
import BranchApi from "../state/branch-api.js";
import EntityApi from "../state/entity-api.js";
import AguserApi from "../state/AguserApi.js";
import AirChargesClientViewv3 from "./AirChargesClientView-v3.js";
import AirPricingSchedule from "../pricing/air.schedule.js";
import FCLPricingSchedule from "../pricing/fcl.schedule.js";
import EntityV2Api from "../state/entities-api.js";
import { dtactionStore } from "../dtactions/dtaction-store.js";
import {PremiumInsurance} from "../mytasks/act-coi-confirmation.js";
import InsuranceIcon from "../assets/images/icon-02.svg";
import EntityApi1 from "../state/entities-api";
import TenantUtils from "../util/tenant.utils.js";
import { airChargesBookingStore, chargesBookingStore1, chargesBookingValidationStore, fclChargesBookingStore } from "../mybooksv3/booking-commonstate.js";
import { chargesData1 } from "../StaticData.js";
import { AirChargesComp, FCLChargesComp, LCLChargesComp } from "../mytasks/act-update-cost.js";
import MonApi, { GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
import { chargesValidationStore } from "../state/validation-stores.js";
import BookingsApi from "../state/bookings-api.js";
import Taskfiledisplay from "../mytasks/task-file-display.js";
import LCLChargeClientViewv3 from "./LCLChargeClientView-v3.js";
import FCLChargeClientViewv3 from "./FCLChargeClientView-v3.js";
import { taskStore } from "../mytasks/task-store.js";
import { ActChargesAirView, ActChargesView, ActFCLChargesView } from "../mytasks/act-additional-cost-approval.js";
import QuoteCalcV2 from "../util/quote-calc-v2.js";
import { Col8, Cols } from "../Controls.js";
import { QuoteCharges1 } from "../state/Types.js";
import { AiChargeHistory, loadAiHistory, getAiHistory } from "../components/AiChargeParse";

export function DummySchedulev3({ stype, dummyContract, showbooking,...props }) {
  const [showCharges, setShowCharges] = useState(false);
  const [branches, setbranches] = useState([]);
  const [premium, setpremium] = useState(false);
  const [policy, setpolicy] = useState();
  const [entityData, SetEntityData] = useState();
  const [edit,setEdit] = useState(false)
  const [activeTab, setActiveTab] = useState('');
  const [showHistory, setShowHistory] = useState(false);
  const [cost, setCost] = useState(false);
  const [costdata, setCostdata] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const [open,setOpen] = useState(false)
  


  let client = loginStore.isClient();
  useSnapshot(contractsStore)
  useSnapshot(bookingsStore)
  useSnapshot(configStore)
  let brec = bookingsStore.current
  let rec = contractsStore.current
const logo=`/assets/${process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE}/logo_name.svg`

  const getEntitydata = async () => {
    let entityData = await EntityApi1.viewEntity(rec?.entityId);
    return entityData;
  };

  async function chargesListDiff(type) {
    chargesValidationStore.onSaveBtnClicked();
    let chargesList
    if (type.indexOf("FCL") >= 0) {
      type = "FCL"
    }
    if (type.indexOf("FCL") >= 0) {
      fclChargesBookingStore.calculateChargesTotalsindex("list", contractsStore.current.emptycontainerweight);
      chargesList = fclChargesBookingStore.list;
    } else if (type.indexOf("Air") >= 0) {
      airChargesBookingStore.checktotal = airChargesBookingStore.checktotal + 1
      cargoStore.calculateCargoTotals()
      airChargesBookingStore.calculateChargesTotalsindex('list')
      chargesList = airChargesBookingStore.list;
    } else {
      chargesBookingStore1.checktotal = chargesBookingStore1.checktotal + 1
      cargoStore.calculateCargoTotals()
      chargesBookingStore1.calculateLCLChargesTotals()
      chargesList = chargesBookingStore1.list;
    }
    chargesList = chargesList?.filter(e => e.chargeDescription && e.currency)
    let result = bookingsStore?.current?.contract?.history?.length > 0 ? bookingsStore?.current?.contract?.history : [];
      result.push({ user: loginStore.email, old: contractsStore.current.chargesList.length > 0 ? contractsStore.current.chargesList:[], new: chargesList.length>0?chargesList:[], updatedAt: Date.now() });
      bookingsStore.current.contract.chargesList = JSON.parse(JSON.stringify(chargesList))
      let k = new QuoteCalcV2(bookingsStore.current.contract).recalc()
      if(k.quoteValue != 0){
        await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  '_id': bookingsStore.current._id,
  "contract.quoteValue": k.quoteValue,
  "contract.quoteValueUSD": k.quoteValueUSD,
  "contract.chargesList": chargesList,
  "contract.history": result,

  "contract.aiChargeHistory": getAiHistory("bookingCharges")
})
        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
          Object.assign(bookingsStore.current, data)
        })
        setEdit(false)
      }else{
        configStore.setModalMessage(`On your account is empty.`);
      }
  }
const onClose = ()=>{
  setEdit(false)
  BookingsApi.getBooking(bookingsStore.current._id, (data) => {
    contractsStore.current = data.contract
    Object.assign(bookingsStore.current, data)
  }) 
}
  const onSubmit  = ()=>{
    chargesListDiff(contractsStore.current.shipmentType)
  }
   useEffect(()=>{
    let scope = contractsStore.current.shipmentScope.split('-to-')
            
    let l = []

    if(props.viewonly){
      let type = contractsStore.current.shipmentType
            
            
            if(JSON.stringify(containerStore.list)!=JSON.stringify(contractsStore.current.containerList)){
                containerStore.list = JSON.parse(JSON.stringify(contractsStore.current.containerList))
            }
            if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(contractsStore.current.cargoList)){
                cargoStore.cargoList = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
            }
            let c
            if(bookingsStore?.current?.contract?.chargesList){
              c = Utils.getChargeList(JSON.parse(JSON.stringify(bookingsStore.current)))
            }else{
              c =contractsStore.current.chargesList
            }
             
            console.log(activeTab,"activetab");
            if(activeTab=='cost'){
              c = []
            }
            if(c!=undefined && c.length==0 ){
                chargesBookingValidationStore.isNew = true
            }else{
                if(type.indexOf("FCL") >= 0){
                    type = "FCL"
                }
                let k = JSON.parse(JSON.stringify(c))
                if (type.indexOf("FCL") >= 0 && JSON.stringify(fclChargesBookingStore.list)!=JSON.stringify(k)) {
                fclChargesBookingStore.initialLength = k.length;
                fclChargesBookingStore.list = k;
                } else if (type.indexOf("Air") >= 0 && JSON.stringify(airChargesBookingStore.list)!=JSON.stringify(k)) {
                airChargesBookingStore.initialLength = k.length;
                airChargesBookingStore.list = k;
                } else if(JSON.stringify(chargesBookingStore1.list)!=JSON.stringify(k)) {
                  k = Utils.groupedCategoryChargeList({ chargeList: k })
                chargesBookingStore1.initialLength = k.length;
                chargesBookingStore1.list = k;
                }
            }
    }
        
    },[JSON.stringify(contractsStore.current),activeTab,edit])
     const getcost = async () =>{
            if(bookingsStore?.current?._id!='' && activeTab =='Cost'){
                let l = await MonApi.apost(GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, {
  bookingNum: bookingsStore.current._id
})
                if(l.length>0){
                    let l1 = await MonApi.apost(GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, {
  bookingNum: bookingsStore.current._id
})
                    if(l1.length>0){
                      l[0]['approvestatu'] = "PENDING"
                    }else{
                      l[0]['approvestatu'] = "APPROVE"
                    }
                    if(cost==false){
                        setCost(true)
                    }
                    if(JSON.stringify(l[0])!=JSON.stringify(costdata)){
                        setCostdata(l[0])
                    }
                }else{
                    if(cost!=false){
                        setCost(false)
                    }
                }
            }
        }
        useEffect(()=>{
                      console.log(costdata,"chekcing for costdata",activeTab);
            getcost()
            
        },[JSON.stringify(AgmodalStore),bookingsStore.current,taskStore.current,taskStore.triggerActionVisible,activeTab])
  useEffect(()=>{
    if(entityData==undefined || entityData.length==0){
      getEntitydata().then((data1) => {
          SetEntityData(data1);
        });
    }
  },[])
  if (dummyContract) rec = dummyContract
  if (!rec) return <></>
  let voldis = 0
    rec['chargesList'].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            voldis = e.total * erate
        }
    })
    let usdRate = configStore.getExchangeRate('USD')
    let voldisusd = voldis / usdRate
    if(voldis>0){
      voldis = -(voldis)
      voldisusd = -(voldisusd)
  }
  let airlogo = logo
  if(rec && rec.airline && rec.airline.trim().length>0){
    if(rec.airline.trim().length>2){
      airlogo = airlogoMap[rec.airline
        .substring(
          rec.airline.lastIndexOf("(") + 1,
          rec.airline.lastIndexOf(")")
        )
        .trim()]
    }else if(rec.airline.trim().length==2) {
      airlogo = airlogoMap[rec.airline.trim()]
    }
  }
  if(brec && brec.airline && brec.airline.trim().length>0){
    if(brec.airline.trim().length>2){
      airlogo = airlogoMap[brec.airline
        .substring(
            brec.airline.lastIndexOf("(") + 1,
            brec.airline.lastIndexOf(")")
        )
        .trim()]
    }else if(brec.airline.trim().length==2) {
        airlogo = airlogoMap[brec.airline]
    }
  }
  if (brec && brec.iata) airlogo = airlogoMap[brec.iata]
  if (bookingsStore.current.createdFromPricing){
    console.log("+========== csdbsj");
    
    if(stype=="LCL"){
      return <LCLPricingSchedule contract={bookingsStore.current.contract} showbooking={showbooking} isDummy={true} viewonly={true} nobutton={true}/>
    }
    if(stype=="AIR"){
      return <AirPricingSchedule contract={bookingsStore.current.contract} showbooking={showbooking} isDummy={true} viewonly={true} nobutton={true}/>
    }
    if(stype=="FCL"){
      return <FCLPricingSchedule contract={bookingsStore.current.contract} showbooking={showbooking} isDummy={true} viewonly={true} nobutton={true}/>
    }
  }
   async function checkBranchGst(data){
    let isGstAvail = false
  await  data.map((r,i)=>{
    if( r.status === BRANCH_STATUS.VERIFIED && r.gst.length > 0 && r.branchAddresses[0].address.length > 0) {
      isGstAvail= true
     return isGstAvail
    } 
    } 
    )
    return isGstAvail

   }
  return (

    <div className="">
      <PremiumInsurance  data={(data)=>{
       setpremium(data)
      }} ></PremiumInsurance>
      <div className="columns" style={{ fontSize: "0.8rem" }}>
        <div
          className="column is-1"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0px",
          }}
        >
          {stype.toLowerCase() === "air" || stype.toLowerCase() === "lcl" || brec.iata ? (
            <img src={airlogo} />
          ) : (
            <>
            {
            (rec.carrier==`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}` && rec.scac && rec.scac.length>0)?
            <img src={schLogoMap[rec.scac]} alt={rec.scac}/>:
            <>
            {
              (rec.carrier==`${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}` && (rec.scac==undefined || rec.scac.length==0))?
              <img src={airlogo} />:
              <img
                src={
                  schLogoMap[
                    rec.carrier
                      .substring(
                        rec.carrier.lastIndexOf("(") + 1,
                        rec.carrier.lastIndexOf(")")
                      )
                      .trim()
                  ] || (rec.scac ? schLogoMap[rec.scac] : null) || schLogoMap[rec.carrier]
                }
                alt={rec.carrier}
                style={{ maxHeight: "35px", maxWidth: "65px", objectFit: "contain" }}
                onError={(e) => {
                  e.currentTarget.style.display = "none"
                }}
              />
            }
            </>
            }
            </>
          )}
        </div>
        <div className="column is-9">
          <div className="columns" style={{ flexDirection: "column" }}>
            <div style={{ alignSelf: "center" }}>
            {
                (rec.transitTime!=undefined && Number(rec.transitTime)>0)?<>
                <p style={{ color: "grey" }}>{rec?.reworkingPort ?'First Leg ':'Total '}Transit Time</p>
              <p style={{ fontSize: "0.9rem", textAlign: "center" }}>
                <strong>{rec.transitTime} days</strong>
              </p>
                </>:<p style={{ color: "grey" }}>Schedule Awaited</p>
              }
            </div>
            <table
              className="schtable"
              style={{ width: "100%", textAlign: "center" }}
            >
              <tr>
                {rec.origin !== rec.portOfReceipt && (
                  <td style={{ textAlign: "center" }}>{rec.origin}</td>
                )}
                <td style={{ textAlign: "center" }}>{rec.portOfReceipt}</td>
                {rec.portOfReceipt !== rec.portOfLoading && (
                  <td style={{ textAlign: "center" }}>{rec.portOfLoading}</td>
                )}
                <td></td>
                <td></td>
                {rec.reworkingPort &&rec.shipmentType==="LCL" && < td style={{ textAlign: "center" }}>
                  {rec.reworkingPort}
                </td>}
                {rec.portOfDischarge !== rec.finalPlaceOfDelivery && (
                  <td style={{ textAlign: "center" }}>{rec.portOfDischarge}</td>
                )}
                  < td style={{ textAlign: "center" }}>
                  {rec.finalPlaceOfDelivery}
                </td>
                {rec.destination !== rec.finalPlaceOfDelivery && (
                  <td style={{ textAlign: "center" }}>{rec.destination2!=undefined && rec.destination2.length>0?"Multiple":rec.destination}</td>
                )}
              </tr>
              <tr>
                {rec.origin !== rec.portOfReceipt && (
                  <td>
                    <CustomProgressDottedBar
                      setStyle={(dotted, hide) => [
                        hide,
                        ["Door-to-Port", "Door-to-Door"].includes(
                          rec.shipmentScope
                        )
                          ? dotted
                          : false,
                      ]}
                    />
                  </td>
                )}
                <td>
                  <CustomProgressDottedBar
                    setStyle={(dotted, hide) => [
                      ["Door-to-Port", "Door-to-Door"].includes(
                        rec.shipmentScope
                      )
                        ? dotted
                        : rec.origin !== rec.portOfReceipt
                          ? false
                          : hide,
                      false,
                    ]}
                  />
                </td>
                {rec.portOfReceipt !== rec.portOfLoading && (
                  <td>
                    <CustomProgressDottedBar
                      setStyle={(dotted, hide) => [false, false]}
                    />
                  </td>
                )}
                <td>
                  <Line />
                </td>
                <td>
                  <Line />
                </td>
                {rec.portOfDischarge !== rec.finalPlaceOfDelivery && (
                  <td>
                    <CustomProgressDottedBar
                      setStyle={(dotted, hide) => [false, false]}
                    />
                  </td>
                )}
                 {rec.reworkingPort && rec.shipmentType === "LCL" && (
    <td>
      <CustomProgressDottedBar setStyle={() => [false, false]} />
    </td>
  )}
                <td>
                  <CustomProgressDottedBar
                    setStyle={(dotted, hide) => [
                      false,
                      ["Door-to-Door", "Port-to-Door"].includes(
                        rec.shipmentScope
                      )
                        ? dotted
                        : rec.destination !== rec.finalPlaceOfDelivery
                          ? false
                          : hide,
                    ]}
                  />
                </td>
                {rec.destination !== rec.finalPlaceOfDelivery && (
                  <td>
                    <CustomProgressDottedBar
                      setStyle={(dotted, hide) => [
                        ["Door-to-Door", "Port-to-Door"].includes(
                          rec.shipmentScope
                        )
                          ? dotted
                          : false,
                        hide,
                      ]}
                    />
                  </td>
                )}
              </tr>
            </table>
          </div>
        </div>
        <div className="column is-2" style={{ textAlign: "center" }}>
        {
                        ((rec.quoteValue+voldis) < 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD, 'USD')}</div>
                                {voldis<0 && <div style={{ fontSize: '1.0rem' }}>(Less) Volume Discount <strong>{Utils.N(voldis)}</strong></div>}
                            </> : <>
                            <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue+voldis)}</strong></div>
                            <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD+voldisusd, 'USD')}</div>
                            </>
                    }


          {((!props.viewonly && rec.quoteStatus == 'ACCEPTED' && rec.status === 'SCHEDULES_UPLOADED') && (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOAD_SCHEDULE.PLACE_BOOKING) || client)) && (contractsStore.current['quoteStatus'] === "ACCEPTED") ? (
            <><div style={{ fontSize: "0.6rem", color: "grey" }}>
            (Taxes, as Applicable)
          </div>
          <div style={{display:"flex",justifyContent: "center", alignItems: "center" }}>
          <button
              className={
                configStore.scheduleOrCarrierform.toString() === "carrierform"
                  ? "button is-rounded is-link is-small is-hidden"
                  : "button is-rounded is-link is-small"
              }
              onClick={() => {
                Utils.checkBookingBlocked({
                  rec,
                  shipmentType: rec.shipmentType || configStore.homescreenCurrentShipmentType,
                  onProceed: () => {
                    EntityV2Api.viewEntity(rec.entityId , (data)=> {
                      if(data.status === ENTITY_STATUS.DEACTIVATED  ){
                        configStore.setModalMessage(`Entity ${data.entityName} is Deactivated , please Activate it for Procced to booking `)
                      }
                      else if (data?.entityCountry?.toLowerCase() === 'india' && (data?.branch[0]?.gst?.length < 1 || data?.branch[0]?.branchAddresses[0]?.address < 1 || data?.branch[0]?.state?.length < 1)) {
                        if (loginStore.isClient()) {
                          let dataObject = {
                            cb: data?.customer?.crossBorder?.relationshipManager,
                            dt: data?.customer?.domesticTransport?.relationshipManager
                          }

                          AguserApi.getProfile(dataObject, (data) => {
                            let message = "Please update your KYC before proceeding for the Booking. Please reach out to your Relationship Manager if you face any challenges "

                            if (data?.CB_User || data?.DT_User) {
                              let user = data?.CB_User || data?.DT_User
                              message += `please contact ${user?.firstName} on ${user?.phonePrefix} ${user?.phone} or ${user?.email} or ${data?.PAT_User?.email}`
                            } else if (data?.PAT_User) {
                              message += `please contact on ${data?.PAT_User?.email}`
                            }

                            configStore.setModalMessage(message)
                          })
                        } else {
                          configStore.setModalMessage('Please Update at least one GST and Address to place the Booking')
                        }
                      }
                      else if (data?.entityCountry?.toLowerCase() !== 'india' && (data?.tinNum?.length < 1 || data?.branch[0]?.branchAddresses[0]?.address?.length < 1 || data?.branch[0]?.state?.length < 1)){
                        if (loginStore.isClient()) {
                          let dataObject = {
                            cb: data?.customer?.crossBorder?.relationshipManager,
                            dt: data?.customer?.domesticTransport?.relationshipManager
                          }

                          AguserApi.getProfile(dataObject, (data) => {
                            let message = "Please update your KYC before proceeding for the Booking. Please reach out to your Relationship Manager if you face any challenges "

                            if (data?.CB_User || data?.DT_User) {
                              let user = data?.CB_User || data?.DT_User
                              message += `please contact ${user?.firstName} on ${user?.phonePrefix} ${user?.phone} or ${user?.email} or ${data?.PAT_User?.email}`
                            }
                            else if (data?.PAT_User) {
                              message += `please contact on ${data?.PAT_User?.email}`
                            }
                          
                            configStore.setModalMessage(message)
                          })
                        } else {
                          configStore.setModalMessage('Please update the Tax Identification Number and Address to place the Booking')
                        }
                      }
                      else {
                        bookingsStore.initialize();
                        bookingsStore.current.schedule = {};
                        bookingsStore.current.contract = { ...rec };
                        bookingsStore.current.isInsured = rec.isInsured==='Yes'?'Yes':'No';
                        bookingsStore.current.hasToShowDummySchedule = true;
                        bookingsStore.current.contractNum = rec._id;
                        bookingsStore.current.fbaDetails = Utils.fbaDetails(rec);
                        configStore.scheduleOrCarrierform = "carrierform";
                      }
                    })
                  }
                })
              }}
            >
              Proceed to Booking
            </button>
            {/* <button className={
                configStore.scheduleOrCarrierform.toString() === "carrierform"
                  ? "button is-rounded is-link is-small is-hidden"
                  : "button is-rounded is-link is-small"
              } style={{marginLeft:"8px"}} onClick={()=>{
                configStore.coiModalVisible2=true
              }}>Insurance</button> */}
              { (rec.shipmentType=="LCL"||rec.shipmentType.includes("FCL")) && entityData?.entityCountry.toLowerCase()=="india"
              && rec?.portOfReceipt.toLowerCase().includes("india")==true && TenantUtils.isAgraga() && rec.multidest.length == 1 ?

              <div >
                <button className={
                configStore.scheduleOrCarrierform.toString() === "carrierform"
                  ? "button is-rounded is-link is-small is-hidden"
                  : "blinking"
              }
              style={{marginLeft:"8px",cursor:"pointer",display: "inline-block", border: "none",animation: "blink 1s infinite"}} onClick={()=>{
                   configStore.coiModalVisible2=true
                 }}>
                    <img src={InsuranceIcon} alt="Insurance Icon" width="54" height="70" />
                </button>
            </div>:""}
            </div>
            
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      {
        showbooking == '1' ? <>
      <div className="columns">
        {RoleUtils.canViewBookingRevenueDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
          <ToggleButton
            isOpen={activeTab == 'Revenue'}
            onClick={() =>{ 
                setActiveTab(activeTab == 'Revenue' ? '' : 'Revenue')
                setEdit(false)
            }}            
            openText="View Revenue Details"
            closeText="Hide Revenue Details"
          />
        </div>}
        {RoleUtils.canViewBookingCostDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
          <ToggleButton
            isOpen={activeTab == 'Cost'}
            onClick={() =>{ 
              setActiveTab(activeTab == 'Cost' ? '' : 'Cost')
              setEdit(false)
            }}
            openText="View Cost Details"
            closeText="Hide Cost Details"
          />
        </div>}
      </div>

  <div className={activeTab === 'Revenue' || activeTab === 'cost' ? 'box' : ''} style={{ fontSize: '0.8rem' }}>
    {activeTab == 'Revenue' && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    
    <h4 className="title is-6" style={{ margin: 0 }}>Revenue Details</h4>

    <div style={{ display: 'flex', gap: '10px' }}>
      {
        (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.contract?.history?.length > 0) ?
        <button
          className="button "
          onClick={() => setShowHistory(true)}
          style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
        >
          History
        </button>:<></>
        }
        {
          (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.status != 'CANCELLED') ?
          <button className="button" onClick={()=>{
              loadAiHistory("bookingCharges", `${bookingsStore.current?._id}-${Date.now()}`, bookingsStore.current?.contract?.aiChargeHistory)

              setEdit(true)
          }} style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}>Edit</button>
          :<></>
        }
        </div>
        </div>
          {!edit && <AiChargeHistory history={rec?.aiChargeHistory} chargeKey="all" />}
          <div
            className="columns"
            style={{
              fontSize: "0.8rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop:'20px'
            }}
          >
            {
              edit?
              contractsStore.current.shipmentType.indexOf("LCL") >= 0 && (<LCLChargesComp aiScope="bookingCharges" />):
              stype.toLowerCase() === "lcl" && <LCLChargeClientViewv3 dummyContract={rec}/>
            }
            {
              edit?
              contractsStore.current.shipmentType.indexOf("FCL") >= 0 && (<FCLChargesComp type={'Edit Charges'} aiScope="bookingCharges" />):
              stype.toLowerCase() === "fcl" && <FCLChargeClientViewv2 dummyContract={rec}/>
            }
            {
              edit?
              contractsStore.current.shipmentType.indexOf("Air") >= 0 && (<AirChargesComp type={'Edit Charges'} aiScope="bookingCharges" />):
              stype.toLowerCase() === "air" && <AirChargesClientViewv3 dummyContract={rec}/>
            }
          </div>
          {
            edit?<div style={{display:'flex',justifyContent:'flex-end',gap:'10px'}}>
            <button onClick={()=>{
              onClose()
            }} className="button is-danger" >Cancel</button>
            <button onClick={()=>{
              setOpen(true)
            }} className="button is-link" >Save</button>
            </div>:<></>
          }        
      </div>
    )}

    {activeTab == 'Cost' && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h4 className="title is-6" style={{ margin: 0 }}>Cost Details</h4>
        </div>
          <div
            className="columns"
            style={{
              fontSize: "0.8rem",
              display: "flex",
              flexDirection:'column',
              alignItems: "center",
              justifyContent: "center",
              paddingTop:'20px',
              paddingBottom:'20px'
            }}
          >
            {(costdata && cost)?(
            <>
            {
                 (stype.indexOf("FCL") >= 0)?(<FCLChargeClientViewv3 dummyContract={costdata}/>) :<>
                 {
                    (stype.indexOf("AIR") >= 0)?(<AirChargesClientViewv3 dummyContract={costdata}/>) :
                    (<LCLChargeClientViewv3 dummyContract={costdata}/> 
                  )}
                 </>
            }
            <p><strong>Gross Profit value: </strong>{costdata.profit!=undefined?costdata.profit.toFixed(2):""}</p>
            <p><strong>Gross Profit percentage: </strong>{costdata.profit_percentage!=undefined?costdata.profit_percentage.toFixed(2):""}</p>
            {(costdata['approvestatu']!=undefined && costdata['approvestatu']=="PENDING") && <p><strong>Approval for Loss is in pending status.</strong></p>}
            {
              costdata?.files?.length > 0&&(
              <Taskfiledisplay
             notshow={true} validation={true} task={costdata}/>)
            }
             </>):(<h1>No Cost Data available</h1>)
          }
          </div>
      </div>
    )}
  </div>
      { open && (
        <ProceedPopup open={open} close={()=>setOpen(false)} onClick={onSubmit}/>
      )}
      {showHistory && (
        <HistoryModal type={stype} show={showHistory} title='Revenue History' data={bookingsStore?.current?.contract?.history || []} onClose={() => setShowHistory(false)}/>
      )}
        </>:<>
        <div className="columns" style={{ fontSize: "0.8rem" }}>
        {showCharges ? (
          <button
            className="button is-warning is-small is-fullwidth"
            onClick={() => setShowCharges(false)}
          >
            Hide Detailed Pricing
            <span className="icon" style={{ marginLeft: "5px" }}>
              <i className="fas fa-sort-up"></i>
            </span>
          </button>
        ) : (
          <button
            className="button is-info is-small is-fullwidth"
            onClick={() => setShowCharges(true)}
          >
            View Detailed Pricing
            <span className="icon" style={{ marginLeft: "5px" }}>
              <i className="fas fa-sort-down"></i>
            </span>
          </button>
        )}
      </div>
        {showCharges  ? (
        <div
          className="columns"
          style={{
            fontSize: "0.8rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {
            stype.toLowerCase() === "lcl" && <LCLChargeClientViewv3 dummyContract={rec}/>
          }
          {
            stype.toLowerCase() === "fcl" && <FCLChargeClientViewv2 dummyContract={rec}/>
          }
          {
            stype.toLowerCase() === "air" && <AirChargesClientViewv3 dummyContract={rec}/>
          }
        </div>
      ) : (
        <></>
      )}
        </>
      }
      
    </div>
  );
}


export function ProceedPopup({ open, close, onClick }) {
  const modalClass = open ? "modal is-active" : "modal";
  return (
    <div className={modalClass}>
      <div className="modal-background" onClick={close}></div>

      <div
        className="modal-card"
        onClick={(e) => e.stopPropagation()} 
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
          <div style={{ textAlign: "center", color: "darkblue", fontSize: "25px", marginBottom: "20px" }}>
            Are you sure you want to change the charges?
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button
              className="button is-warning"
              onClick={close} 
            >
              Cancel
            </button>
            <button
              className="button is-danger"
              onClick={() => {
                if (onClick) onClick(); 
                close(); 
              }}
            >
              Submit
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}


export const ToggleButton = ({ label, isOpen, onClick,openText,closeText }) => {
  return (
    <button
      className={`button ${isOpen ? "is-warning" : "is-info"} is-small is-fullwidth`}      onClick={onClick}
    >
      {isOpen ? closeText : openText}     
       <span className="icon ml-2">
        <i
          className={`fas ${
            isOpen ? "fa-sort-up" : "fa-sort-down"
          }`}
        ></i>
      </span>
    </button>
  );
};

export const HistoryModal = ({
  show,
  title = 'History',
  data = [],
  onClose,
  type
}) => {
  if (!show) return null;

  return (
    <div className="modal is-active">
      <div
        className="modal-background"
        onClick={onClose}
      ></div>

      <div className="modal-card" style={{ width: '60%' }}>
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button
            className="delete is-danger"
            aria-label="close"
            onClick={onClose}
          />
        </header>

        <section className="modal-card-body">
          <div style={{display:'flex',justifyContent:'space-between'}}>
          {/* {<span><strong>Action Type: </strong> {data[data?.length - 1]?.type} </span>} */}
          {<span><strong>Updated By: </strong> {data[data?.length - 1]?.user} </span>}
          {<span><strong>Updated At: </strong> {Utils.formatToDateTime(data[data?.length - 1]?.updatedAt)} </span>}
          </div>
              {
              (type.toUpperCase().indexOf('LCL') >= 0) ?(
                   <>
                {data[data?.length - 1]?.old?.length > 0 && Object.hasOwn(data[data?.length - 1], 'old')?  (
                    <><strong>Orginal Cost</strong>
                    <ActChargesView chargelist={data[data?.length - 1]?.old?.length > 0 ? data[data?.length - 1]?.old : [data[data?.length - 1]?.old]} name={'originalCost'}/>
                   <hr /></>):<></>
                   }
                {data[data?.length - 1]?.new?.length > 0 && Object.hasOwn(data[data?.length - 1], 'new') ?  (
                   <><strong>Revised Cost</strong>
                    <ActChargesView chargelist={data[data?.length - 1]?.new?.length > 0 ? data[data?.length - 1]?.new : [data[data?.length - 1]?.new] } total = {true} name={'revisedCost'}/>
                   </>):<></>
                   }
                   </>) :
                    <></>
               }
               {
                   (type.toUpperCase().indexOf('AIR') >= 0) ?(
                    <>
                {data[data?.length - 1]?.old?.length > 0 && Object.hasOwn(data[data?.length - 1], 'old')  ?  (
                   <><strong>Orginal Cost</strong>
                   <ActChargesAirView chargelist={data[data?.length - 1]?.old} name={'originalCost'}/>
                   <hr /></>):<></>
                   }
                {data[data?.length - 1]?.new?.length > 0 && Object.hasOwn(data[data?.length - 1], 'new') ?  (
                   <><strong>Revised Cost</strong>
                   <ActChargesAirView chargelist={data[data?.length - 1]?.new}  total = {true} name={'revisedCost'} />
                   </>):<></>
                   }
                   </>) :
                   <></>
               }
               {
                   (type.toUpperCase().indexOf('FCL') >= 0) ?(
                    <>
                {data[data?.length - 1]?.old?.length > 0 && Object.hasOwn(data[data?.length - 1], 'old')  ?  (
                      <><strong>Orginal Cost</strong>
                      <ActFCLChargesView chargelist={data[data?.length - 1]?.old} container={bookingsStore.current.contract.containerList} name={'originalCost'} />
                      <hr /></>):<></>
                   }
                {data[data?.length - 1]?.new?.length > 0 && Object.hasOwn(data[data?.length - 1], 'new')   ?  (
                   <><strong>Revised Cost</strong>
                      <ActFCLChargesView chargelist={data[data?.length - 1]?.new} container={bookingsStore.current.contract.containerList} total = {true} name={'revisedCost'} />
                      </>):<></>
                    }
                       </>):
                       <></>
               }
        </section>

        <footer
          className="modal-card-foot"
          style={{ justifyContent: 'flex-end' }}
        >
          <button className="button is-danger" onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
};

 